// removed by extract-text-webpack-plugin
module.exports = {"page":"_1l3t6SIuxIsAmX-bnipD9B pageWrap-l paddingBottom-xl centered","leftColumn":"Ju-mpIxoeoX_zacHKWdeu position-fixed paddingTopBottom-xl overflow-scroll","rightColumn":"fsTRvLNOFqxiy51PF_7U0"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/style/docs.css
// module id = 1516
// module chunks = 144482056661899